// @flow

import CellManager from '@/lib/cell_manager';
import Settings from '@/lib/settings';
import { ResetParameters, SpawnEvent } from '@/lib/cell_event';

export default class {
  manager: CellManager;
  id: string;
  x: number;
  y: number;
  elevation: number;
  _defaultWater: number;
  _water: number;
  _defaultGreen: number;
  _green: number;
  _defaultSoilNutrition: number;
  _soilNutrition: number;
  _sunlight: number;
  events: CellEventCallable[];
  unitIds: number[];

  constructor(manager: CellManager, x: number, y: number, elevation: number) {
    this.manager = manager;
    this.x = x;
    this.y = y;
    this.id = this.manager.makeCellId(this.x, this.y);
    this.elevation = elevation;
    // 高度から計算した値を水分量、土壌栄養量のデフォルト値として使う
    const coefficient = 1.5;
    this._defaultWater = 100 - this.elevation * coefficient;
    this.water = this._defaultWater;
    this._defaultSoilNutrition =
      (100 - this.elevation * 0.4) / Settings.difficulty;
    this.soilNutrition = this._defaultSoilNutrition;
    this._defaultGreen = 0;
    this.green = this._defaultGreen;
    this.sunlight = Settings.sunlight;
    this.events = [ResetParameters, SpawnEvent];
    this.unitIds = [];
  }

  process() {
    this.events.forEach(event => event.process(this));
  }

  addUnit(unitTemplate: UnitTemplate) {
    // TODO: Cell が unitManager と密結合していて良くない
    const unit = this.manager.game.unitManager.createUnit(unitTemplate, this);
    this.unitIds.push(unit.id);
    return unit;
  }

  get units() {
    return this.unitIds.reduce((acc, id) => {
      const unit = this.manager.game.findUnit(id);
      if (unit) acc.push(unit);
      return acc;
    }, []);
  }

  update(field: string, value: number, range: number) {
    if (range === 0) {
      // $FlowFixMe:
      this[field] += value;
      return;
    }

    let startX = this.x - range;
    let endX = this.x + range;
    let startY = this.y - range;
    let endY = this.y + range;

    for (let y = startY; y <= endY; y++) {
      for (let x = startX; x <= endX; x++) {
        let cell = this.manager.find(x, y);
        if (!cell) continue;
        let distance = Math.sqrt(
          Math.pow(x - this.x, 2) + Math.pow(y - this.y, 2)
        );
        if (distance < 1) distance = 1;
        cell.update(field, value / Math.pow(distance, 2), 0);
      }
    }
  }

  getParameter(target: string, field: string) {
    // $FlowFixMe:
    if (target === 'cell') return this[field];
    // TODO セル上のユニットを使った条件判定に対応
    // if (target == 'unit') return this.getUnits(unitId)[field];
    return false;
  }

  get water() {
    return this._water;
  }

  set water(value: number) {
    this._water = this._restrictValue(value);
  }

  get soilNutrition() {
    return this._soilNutrition;
  }

  set soilNutrition(value: number) {
    this._soilNutrition = this._restrictValue(value);
  }

  get green() {
    return this._green;
  }

  set green(value: number) {
    this._green = this._restrictValue(value);
  }

  get sunlight() {
    if (this.elevation < 0) return 0;
    return this._sunlight;
  }

  set sunlight(value: number) {
    this._sunlight = this._restrictValue(value);
  }

  _restrictValue(value: number) {
    if (value > 100) {
      return 100;
    } else if (value < 0) {
      return 0;
    }

    return value;
  }
}



// WEBPACK FOOTER //
// ./src/lib/cell/cell.js